// Field specs for the four detail lists. DetailListCard is generic; this is the
// only place the shape of a moment, job, degree, or location is described for
// the UI. Keys must match src/lib/connectionDetails.js.

/** "2025-03" → "Mar 2025". Falls back to the raw string. */
export function formatMonth(value) {
  if (!value) return "";
  const [year, month] = String(value).split("-");
  if (!year) return value;
  if (!month) return year;
  const date = new Date(Number(year), Number(month) - 1, 1);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString("en-US", { month: "short", year: "numeric" });
}

function jobRange(item) {
  if (item.current) return "Current";
  const start = formatMonth(item.start);
  const end = formatMonth(item.end);
  if (start && end) return `${start} – ${end}`;
  return start || end || "";
}

export const SECTIONS = Object.freeze({
  moments: {
    listKey: "moments",
    title: "Moments Together",
    addLabel: "+ Add moment",
    emptyCopy: "Trips, parties, dinners — the things you would actually bring up next time.",
    fields: [
      { key: "title", label: "What happened", placeholder: "Columbia homecoming weekend", required: true },
      { key: "date", label: "When", type: "month", width: "half" },
      { key: "note", label: "Note", type: "textarea", placeholder: "Anything worth remembering" },
    ],
    renderItem: (item) => item.title,
    renderMeta: (item) => formatMonth(item.date),
    renderSub: (item) => item.note || "",
  },

  career: {
    listKey: "career",
    title: "Career",
    addLabel: "+ Add job",
    emptyCopy: "Where they have worked.",
    fields: [
      { key: "title", label: "Role", placeholder: "Senior Editor", required: true },
      { key: "org", label: "Organization", placeholder: "Condé Nast" },
      { key: "start", label: "From", type: "month", width: "half" },
      { key: "end", label: "To", type: "month", width: "half" },
      { key: "current", label: "Current role", type: "checkbox" },
    ],
    renderItem: (item) => (item.org ? `${item.title} @ ${item.org}` : item.title),
    renderMeta: jobRange,
  },

  education: {
    listKey: "education",
    title: "Education",
    addLabel: "+ Add education",
    emptyCopy: "Schools, programs, and years.",
    fields: [
      { key: "school", label: "School", placeholder: "Columbia University", required: true },
      { key: "degree", label: "Degree or program", placeholder: "BA, Journalism" },
      { key: "year", label: "Year", placeholder: "2015", width: "half" },
    ],
    renderItem: (item) => item.school,
    renderMeta: (item) => item.year || "",
    renderSub: (item) => item.degree || "",
  },

  locations: {
    listKey: "locations",
    title: "Locations",
    addLabel: "+ Add location",
    emptyCopy: "Where they live now, and where they have been.",
    fields: [
      { key: "label", label: "Place", placeholder: "New York, NY", required: true },
      { key: "current", label: "Lives here now", type: "checkbox" },
    ],
    renderItem: (item) => item.label,
    renderMeta: (item) => (item.current ? "Current" : ""),
  },
});
